import React from 'react';
import styled from 'styled-components';
import colors from 'theme/colors';

const StyledInput = styled.input<any>`
  width: ${props => props.width};
  font-size: 15px;
  font-weight: 500;
  padding: 10px;
  margin-bottom: ${props => props.mb};
  border: 1px solid ${colors.darkGray};
  outline: none;
  ::-webkit-input-placeholder {
    color: ${colors.lightGray};
    font-size: 15px;
    font-weight: 500;
  }
  ::-moz-placeholder {
    color: ${colors.lightGray};
    font-size: 15px;
    font-weight: 500;
  }
  :-ms-input-placeholder {
    color: ${colors.lightGray};
    font-size: 15px;
    font-weight: 500;
  }
  :-moz-placeholder {
    color: ${colors.lightGray};
    font-size: 15px;
    font-weight: 500;
  }
  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;

export const StyledShareLinkInput = styled.input<any>`
  width: ${props => props.width};
  font-size: 15px;
  padding: 10px;
  border-bottom: 2px solid ${colors.darkGray};
  outline: none;
  background: transparent;
  ::-webkit-input-placeholder {
    color: ${colors.lightGray};
    font-size: 16px;
  }
  ::-moz-placeholder {
    color: ${colors.lightGray};
    font-size: 16px;
  }
  :-ms-input-placeholder {
    color: ${colors.lightGray};
    font-size: 16px;
  }
  :-moz-placeholder {
    color: ${colors.lightGray};
    font-size: 16px;
  }
  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;

export const StyledTextArea = styled.textarea<any>`
  width: ${props => props.width};
  height: ${props => props.height};
  resize: none;
  font-size: 15px;
  font-weight: 500;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid ${colors.darkGray};
  outline: none;
  ::-webkit-input-placeholder {
    color: ${colors.lightGray};
    font-size: 15px;
    font-weight: 500;
  }
  ::-moz-placeholder {
    color: ${colors.lightGray};
    font-size: 15px;
    font-weight: 500;
  }
  :-ms-input-placeholder {
    color: ${colors.lightGray};
    font-size: 15px;
    font-weight: 500;
  }
  :-moz-placeholder {
    color: ${colors.lightGray};
    font-size: 15px;
    font-weight: 500;
  }
  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;

const StyledCheckbox = styled.input<any>`
  width: 15px;
  outline: none;
`;

const Input: React.FC<any> = ({ type, numberInputMin, numberInputMax, ...props }) => {
  switch (type) {
    case 'shareLink':
      return <StyledShareLinkInput type="email" {...props} />;
    case 'textarea':
      return <StyledTextArea type={type} {...props} />;
    case 'checkbox':
      return <StyledCheckbox type={type} {...props} />;
    case 'number':
      return (
        <StyledInput type={type} value={0} min={numberInputMin} max={numberInputMax} {...props} />
      );
    default:
      return <StyledInput type={type} {...props} />;
  }
};

Input.defaultProps = {
  width: '400px',
  height: '100px',
  mb: '20px',
};

export default Input;
